module.exports = __webpack_public_path__ + "img/sb.d4b8cc23.svg";